import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgClass } from '@angular/common';
import { TranslateDirective } from '@ngx-translate/core';
import { LeakScoreStatus } from '@app/core/enums/leak-score-status.enum';
import { LdLoggerNoiseLeakScoreGaugeComponent } from '@app/main/leak-detection/components/ld-helper/ld-logger-noise-leak-score-gauge/ld-logger-noise-leak-score-gauge.component';

@Component({
  selector: 'gc-ld-logger-noise-score-leak',
  standalone: true,
  imports: [NgClass, TranslateDirective, LdLoggerNoiseLeakScoreGaugeComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './ld-logger-noise-score-leak.component.html',
})
export class LdLoggerNoiseScoreLeakComponent {
  public leakScore = input<number | undefined>();
  public leakScoreStatus = input<LeakScoreStatus | undefined>();
  public small = input<boolean>(false);
}
